import { SearchableSelectField } from "@certn/cascadia-react";
import { usePeopleAPI } from "@certn/legacy-api";
import { Field } from "formik";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Item } from "react-stately";

type OffenseSelectProps = {
  name: string;
  label: string;
  onChange: (offense: { code: string; description: string }) => void;
  testID?: string;
};

export function OffenseSelect({
  name,
  label,
  onChange,
  testID = "offense-select",
}: OffenseSelectProps) {
  const { t } = useTranslation();
  const { data: offenseList, isLoading: offensesLoading } = usePeopleAPI(
    "/internal/people/applicant/criminal-charges/"
  );

  // Parse into list of strings and remove duplicates
  const offences = useMemo(
    () => [
      ...new Set(
        offenseList?.map((offence) => `${offence.code} - ${offence.offense}`)
      ),
    ],
    [offenseList]
  );

  return (
    <Field
      name={name}
      label={label}
      as={SearchableSelectField}
      placeholder={t("Please select")}
      onSelectionChange={(value: string) =>
        onChange({
          code: value?.split(" - ")[0],
          description: value?.split(" - ")[1],
        })
      }
      isRequired
      testID={testID}
    >
      {offensesLoading ? (
        <Item key="Loading">{t("Loading...")}</Item>
      ) : (
        offences.map((offense) => (
          <Item key={offense} textValue={offense}>
            {offense}
          </Item>
        ))
      )}
    </Field>
  );
}
